import { PUBLIC_HIGHLIGHT_SHARE_LINK } from "./constants";

export default highlight =>
  `${PUBLIC_HIGHLIGHT_SHARE_LINK}/${highlight.uniqueId}`;
